import type { SVGProps } from 'react';
export const StockWithDates = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M10.76 4.46a5 5 0 0 0-3.08.32 5.4 5.4 0 0 0-2.41 2.07 5.9 5.9 0 0 0 0 6.3c.59.93 1.43 1.65 2.4 2.07A5.1 5.1 0 0 0 13.5 14a.68.68 0 0 1 .98.94 6.47 6.47 0 0 1-7.34 1.53 7 7 0 0 1-3.02-2.6 7.2 7.2 0 0 1 0-7.75 7 7 0 0 1 3.02-2.58 6.5 6.5 0 0 1 7.34 1.52l1.17 1.22V4.52a.68.68 0 0 1 1.35 0v3.45c0 .37-.3.67-.68.67h-3.3a.68.68 0 0 1 0-1.35h1.72l-1.24-1.3a5.3 5.3 0 0 0-2.74-1.53"
      clipRule="evenodd"
    />
    <path fill="white" fillRule="evenodd" d="M9 14a4 4 0 1 1 8 0 4 4 0 0 1-8 0" clipRule="evenodd" />
    <path
      fill="#6D94CF"
      fillRule="evenodd"
      d="M9.8 14a3.2 3.2 0 1 1 6.4 0 3.2 3.2 0 0 1-6.4 0m3.1-1.67h.03c.13 0 .24.11.24.24v1.52l1.29.76c.11.07.15.22.08.33a.24.24 0 0 1-.33.08l-1.38-.83a.3.3 0 0 1-.16-.28v-1.58c0-.13.1-.24.24-.24"
      clipRule="evenodd"
    />
  </svg>
);
